import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function getAllParkingBayApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.parkingBay,
    method: 'get',
    query
  })
}

export function addNewParkingBayApi(payload) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.parkingBay,
    method: 'post',
    payload
  })
}

export function deleteParkingBayApi(id) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.parkingBay + `/${id}`,
    method: 'delete'
  })
}